(() => {
  'use strict';
  const route = '#chaos-game';
  let current;
  const bytes = value => Uint8Array.from(atob(value), c => c.charCodeAt(0));
  async function decrypt(payload, password) {
    const material = await crypto.subtle.importKey('raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey']);
    const key = await crypto.subtle.deriveKey({name:'PBKDF2', salt:bytes(payload.salt), iterations:payload.iterations, hash:'SHA-256'}, material, {name:'AES-GCM', length:256}, false, ['decrypt']);
    const result = await crypto.subtle.decrypt({name:'AES-GCM', iv:bytes(payload.iv)}, key, bytes(payload.ciphertext));
    return new TextDecoder().decode(result);
  }
  function init() {
    const root = document.querySelector('[data-chaos-portal]');
    if (!root || (current && current.root === root)) return;
    if (current) current.dispose();
    const dialog = root.querySelector('[data-chaos-dialog]');
    const form = root.querySelector('[data-chaos-form]');
    const input = root.querySelector('[data-chaos-password]');
    const submit = root.querySelector('[data-chaos-submit]');
    const error = root.querySelector('[data-chaos-error]');
    const host = root.querySelector('[data-chaos-game]');
    let html, loading, generation = 0, playing = false, opener;
    let pausedViewers=[];
    function busy(value) { submit.disabled=value; input.disabled=value; submit.textContent=value?'LOADING…':'ENTER'; }
    function loadPayload() {
      const embedded = root.querySelector('[data-chaos-payload]');
      if (embedded) return Promise.resolve(JSON.parse(embedded.textContent));
      if (window.CHAOS_LOCKED_GAME) return Promise.resolve(window.CHAOS_LOCKED_GAME);
      if (loading) return loading;
      loading = new Promise((resolve, reject) => {
        const script=document.createElement('script');
        const timer=setTimeout(() => {script.remove(); reject(new Error('load'));},45000);
        script.src=root.dataset.payloadUrl;
        script.onload=() => {clearTimeout(timer); script.remove(); window.CHAOS_LOCKED_GAME?resolve(window.CHAOS_LOCKED_GAME):reject(new Error('load'));};
        script.onerror=() => {clearTimeout(timer); script.remove(); reject(new Error('load'));};
        document.head.append(script);
      }).catch(err => {loading=null; throw err;});
      return loading;
    }
    function showGame() {
      if (playing) return;
      playing=true;
      pausedViewers=Array.from(document.querySelectorAll('[data-drop] model-viewer'),viewer=>({viewer,autoRotate:viewer.autoRotate}));
      pausedViewers.forEach(({viewer})=>{viewer.autoRotate=false;});
      dialog.close();
      input.value='';
      host.hidden=false;
      document.documentElement.classList.add('chaos-playing');
      const frame=document.createElement('iframe');
      frame.title='CHAOS — The Lair';
      frame.allow='fullscreen; clipboard-write';
      frame.srcdoc=html;
      frame.addEventListener('load', () => {if(playing) frame.contentWindow.focus();}, {once:true});
      host.append(frame);
    }
    function stopGame() {
      playing=false;
      host.replaceChildren();
      host.hidden=true;
      document.documentElement.classList.remove('chaos-playing');
      pausedViewers.forEach(({viewer,autoRotate})=>{viewer.autoRotate=autoRotate;});
      pausedViewers=[];
    }
    function openGate() {
      if (html) {showGame(); return;}
      if (dialog.open) return;
      error.textContent=''; input.value=''; busy(false);
      dialog.showModal(); input.focus();
    }
    function navigate() {
      if (location.hash===route) openGate();
      else {generation++; stopGame(); if(dialog.open)dialog.close(); input.value=''; busy(false);}
    }
    function closeGate() {
      generation++;
      if(dialog.open)dialog.close();
      input.value=''; busy(false);
      if(location.hash===route) history.replaceState(null,'',location.pathname+location.search);
      if(opener && opener.isConnected) opener.focus();
    }
    function click(event) {
      const entry=event.target.closest('[data-chaos-entry]');
      if (!entry) return;
      event.preventDefault(); opener=entry;
      if(location.hash!==route) history.pushState(null,'',route);
      openGate();
    }
    async function enter(event) {
      event.preventDefault();
      if(submit.disabled || !form.reportValidity()) return;
      if(!window.crypto || !crypto.subtle) {error.textContent='OPEN THIS PAGE OVER HTTPS TO CONTINUE.'; return;}
      const ticket=++generation, password=input.value;
      busy(true); error.textContent='';
      try {
        const payload=await loadPayload();
        const unlocked=await decrypt(payload,password);
        if(ticket!==generation || !root.isConnected) return;
        html=unlocked;
        showGame();
      } catch(err) {
        if(ticket!==generation || !root.isConnected) return;
        error.textContent=err.name==='OperationError'?'INCORRECT PASSWORD. TRY AGAIN.':'COULD NOT LOAD THE GAME. TRY AGAIN.';
        input.value='';
      } finally {
        if(ticket===generation) {busy(false); if(dialog.open)input.focus();}
      }
    }
    const cancel=event=>{event.preventDefault();closeGate();};
    document.addEventListener('click',click);
    window.addEventListener('hashchange',navigate);
    window.addEventListener('popstate',navigate);
    form.addEventListener('submit',enter);
    dialog.addEventListener('cancel',cancel);
    root.querySelector('[data-chaos-close]').addEventListener('click',closeGate);
    current={root,dispose(){generation++;stopGame();dialog.close();document.removeEventListener('click',click);window.removeEventListener('hashchange',navigate);window.removeEventListener('popstate',navigate);}};
    navigate();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
